export const SET_REGIONS = 'SET_REGIONS';
export const REGIONS_ERROR = 'REGIONS_ERROR';
